import React from 'react'
import { l } from '@ds/index'
import cx from 'classnames'

import { PeriodToggle, PlansCTA } from 'common/billing/experiments'

import { DiscountPercentMap } from '../Paywall/variants/UniversalPaywall/constants'

import { getV3PlanPriceBreakdown } from './getV3PlanPriceBreakdown'
import { PlanCard } from './PlanCard/PlanCard'
import { MigrationPlansViewReady } from './useMigrationPlansView'

import cm from './MigrationPlansView.module.css'

export const TargetPlanCard = ({
  migrationViewData,
}: {
  migrationViewData: MigrationPlansViewReady
}) => {
  const {
    targetData: { slug, type, planName, price, activeContacts: targetActiveContacts, overagePrice },
    activeContacts,
    isPriceDown,
  } = migrationViewData

  const features = getV3PlanPriceBreakdown({
    slug,
    type,
    includedActiveContacts: targetActiveContacts,
    overagePrice,
    activeContacts,
  })

  return (
    <PlanCard
      features={features}
      title={l.translate('{planName} Plan', { planName })}
      enlargeTitle={!isPriceDown}
      price={l.currency(price.amount, price.currency, 0)}
      priceNote={
        <PeriodToggle
          className={cx('bg-default d-inline m-y-xxs', cm.periodToggle)}
          discountPercent={DiscountPercentMap[type]}
        />
      }
      priceBasis={l.translate('New price breakdown:')}
      isCardHighlighted
      footer={
        <PlansCTA
          onConsent={() => migrationViewData.registerConsent(slug)}
          className={cx('bg-accent text-white w-full m-t', cm.ctaAccent)}
          slug={slug}
        >
          {l.translate('Activate your new plan')}
        </PlansCTA>
      }
    />
  )
}
